/* eslint-disable */
import * as $protobuf from 'protobufjs/minimal';

// Common aliases
const $Reader = $protobuf.Reader,
  $Writer = $protobuf.Writer,
  $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = {});

export const qud = ($root.qud = (() => {
  /**
   * Namespace qud.
   * @exports qud
   * @namespace
   */
  const qud = {};

  qud.PartParam = (function () {
    /**
     * Properties of a PartParam.
     * @memberof qud
     * @interface IPartParam
     * @property {string|null} [key] PartParam key
     * @property {string|null} [value] PartParam value
     */

    /**
     * Constructs a new PartParam.
     * @memberof qud
     * @classdesc Represents a PartParam.
     * @implements IPartParam
     * @constructor
     * @param {qud.IPartParam=} [properties] Properties to set
     */
    function PartParam(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * PartParam key.
     * @member {string} key
     * @memberof qud.PartParam
     * @instance
     */
    PartParam.prototype.key = '';

    /**
     * PartParam value.
     * @member {string} value
     * @memberof qud.PartParam
     * @instance
     */
    PartParam.prototype.value = '';

    /**
     * Creates a new PartParam instance using the specified properties.
     * @function create
     * @memberof qud.PartParam
     * @static
     * @param {qud.IPartParam=} [properties] Properties to set
     * @returns {qud.PartParam} PartParam instance
     */
    PartParam.create = function create(properties) {
      return new PartParam(properties);
    };

    /**
     * Encodes the specified PartParam message. Does not implicitly {@link qud.PartParam.verify|verify} messages.
     * @function encode
     * @memberof qud.PartParam
     * @static
     * @param {qud.IPartParam} message PartParam message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PartParam.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.key != null && Object.hasOwnProperty.call(message, 'key'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.key);
      if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.value);
      return writer;
    };

    /**
     * Encodes the specified PartParam message, length delimited. Does not implicitly {@link qud.PartParam.verify|verify} messages.
     * @function encodeDelimited
     * @memberof qud.PartParam
     * @static
     * @param {qud.IPartParam} message PartParam message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PartParam.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PartParam message from the specified reader or buffer.
     * @function decode
     * @memberof qud.PartParam
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {qud.PartParam} PartParam
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PartParam.decode = function decode(reader, length, error) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.qud.PartParam();
      while (reader.pos < end) {
        let tag = reader.uint32();
        if (tag === error) break;
        switch (tag >>> 3) {
          case 1: {
            message.key = reader.string();
            break;
          }
          case 2: {
            message.value = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a PartParam message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof qud.PartParam
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {qud.PartParam} PartParam
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PartParam.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PartParam message.
     * @function verify
     * @memberof qud.PartParam
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PartParam.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.key != null && message.hasOwnProperty('key'))
        if (!$util.isString(message.key)) return 'key: string expected';
      if (message.value != null && message.hasOwnProperty('value'))
        if (!$util.isString(message.value)) return 'value: string expected';
      return null;
    };

    /**
     * Creates a PartParam message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof qud.PartParam
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {qud.PartParam} PartParam
     */
    PartParam.fromObject = function fromObject(object) {
      if (object instanceof $root.qud.PartParam) return object;
      let message = new $root.qud.PartParam();
      if (object.key != null) message.key = String(object.key);
      if (object.value != null) message.value = String(object.value);
      return message;
    };

    /**
     * Creates a plain object from a PartParam message. Also converts values to other types if specified.
     * @function toObject
     * @memberof qud.PartParam
     * @static
     * @param {qud.PartParam} message PartParam
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PartParam.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.key = '';
        object.value = '';
      }
      if (message.key != null && message.hasOwnProperty('key')) object.key = message.key;
      if (message.value != null && message.hasOwnProperty('value')) object.value = message.value;
      return object;
    };

    /**
     * Converts this PartParam to JSON.
     * @function toJSON
     * @memberof qud.PartParam
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PartParam.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PartParam
     * @function getTypeUrl
     * @memberof qud.PartParam
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PartParam.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
      if (typeUrlPrefix === undefined) {
        typeUrlPrefix = 'type.googleapis.com';
      }
      return typeUrlPrefix + '/qud.PartParam';
    };

    return PartParam;
  })();

  qud.PartDef = (function () {
    /**
     * Properties of a PartDef.
     * @memberof qud
     * @interface IPartDef
     * @property {string|null} [name] PartDef name
     * @property {Array.<qud.IPartParam>|null} [params] PartDef params
     */

    /**
     * Constructs a new PartDef.
     * @memberof qud
     * @classdesc Represents a PartDef.
     * @implements IPartDef
     * @constructor
     * @param {qud.IPartDef=} [properties] Properties to set
     */
    function PartDef(properties) {
      this.params = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * PartDef name.
     * @member {string} name
     * @memberof qud.PartDef
     * @instance
     */
    PartDef.prototype.name = '';

    /**
     * PartDef params.
     * @member {Array.<qud.IPartParam>} params
     * @memberof qud.PartDef
     * @instance
     */
    PartDef.prototype.params = $util.emptyArray;

    /**
     * Creates a new PartDef instance using the specified properties.
     * @function create
     * @memberof qud.PartDef
     * @static
     * @param {qud.IPartDef=} [properties] Properties to set
     * @returns {qud.PartDef} PartDef instance
     */
    PartDef.create = function create(properties) {
      return new PartDef(properties);
    };

    /**
     * Encodes the specified PartDef message. Does not implicitly {@link qud.PartDef.verify|verify} messages.
     * @function encode
     * @memberof qud.PartDef
     * @static
     * @param {qud.IPartDef} message PartDef message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PartDef.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.name != null && Object.hasOwnProperty.call(message, 'name'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
      if (message.params != null && message.params.length)
        for (let i = 0; i < message.params.length; ++i)
          $root.qud.PartParam.encode(
            message.params[i],
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified PartDef message, length delimited. Does not implicitly {@link qud.PartDef.verify|verify} messages.
     * @function encodeDelimited
     * @memberof qud.PartDef
     * @static
     * @param {qud.IPartDef} message PartDef message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PartDef.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PartDef message from the specified reader or buffer.
     * @function decode
     * @memberof qud.PartDef
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {qud.PartDef} PartDef
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PartDef.decode = function decode(reader, length, error) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.qud.PartDef();
      while (reader.pos < end) {
        let tag = reader.uint32();
        if (tag === error) break;
        switch (tag >>> 3) {
          case 1: {
            message.name = reader.string();
            break;
          }
          case 2: {
            if (!(message.params && message.params.length)) message.params = [];
            message.params.push($root.qud.PartParam.decode(reader, reader.uint32()));
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a PartDef message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof qud.PartDef
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {qud.PartDef} PartDef
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PartDef.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PartDef message.
     * @function verify
     * @memberof qud.PartDef
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PartDef.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.name != null && message.hasOwnProperty('name'))
        if (!$util.isString(message.name)) return 'name: string expected';
      if (message.params != null && message.hasOwnProperty('params')) {
        if (!Array.isArray(message.params)) return 'params: array expected';
        for (let i = 0; i < message.params.length; ++i) {
          let error = $root.qud.PartParam.verify(message.params[i]);
          if (error) return 'params.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a PartDef message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof qud.PartDef
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {qud.PartDef} PartDef
     */
    PartDef.fromObject = function fromObject(object) {
      if (object instanceof $root.qud.PartDef) return object;
      let message = new $root.qud.PartDef();
      if (object.name != null) message.name = String(object.name);
      if (object.params) {
        if (!Array.isArray(object.params)) throw TypeError('.qud.PartDef.params: array expected');
        message.params = [];
        for (let i = 0; i < object.params.length; ++i) {
          if (typeof object.params[i] !== 'object')
            throw TypeError('.qud.PartDef.params: object expected');
          message.params[i] = $root.qud.PartParam.fromObject(object.params[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a PartDef message. Also converts values to other types if specified.
     * @function toObject
     * @memberof qud.PartDef
     * @static
     * @param {qud.PartDef} message PartDef
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PartDef.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.params = [];
      if (options.defaults) object.name = '';
      if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
      if (message.params && message.params.length) {
        object.params = [];
        for (let j = 0; j < message.params.length; ++j)
          object.params[j] = $root.qud.PartParam.toObject(message.params[j], options);
      }
      return object;
    };

    /**
     * Converts this PartDef to JSON.
     * @function toJSON
     * @memberof qud.PartDef
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PartDef.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PartDef
     * @function getTypeUrl
     * @memberof qud.PartDef
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PartDef.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
      if (typeUrlPrefix === undefined) {
        typeUrlPrefix = 'type.googleapis.com';
      }
      return typeUrlPrefix + '/qud.PartDef';
    };

    return PartDef;
  })();

  qud.StatEntry = (function () {
    /**
     * Properties of a StatEntry.
     * @memberof qud
     * @interface IStatEntry
     * @property {string|null} [key] StatEntry key
     * @property {number|null} [value] StatEntry value
     */

    /**
     * Constructs a new StatEntry.
     * @memberof qud
     * @classdesc Represents a StatEntry.
     * @implements IStatEntry
     * @constructor
     * @param {qud.IStatEntry=} [properties] Properties to set
     */
    function StatEntry(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * StatEntry key.
     * @member {string} key
     * @memberof qud.StatEntry
     * @instance
     */
    StatEntry.prototype.key = '';

    /**
     * StatEntry value.
     * @member {number} value
     * @memberof qud.StatEntry
     * @instance
     */
    StatEntry.prototype.value = 0;

    /**
     * Creates a new StatEntry instance using the specified properties.
     * @function create
     * @memberof qud.StatEntry
     * @static
     * @param {qud.IStatEntry=} [properties] Properties to set
     * @returns {qud.StatEntry} StatEntry instance
     */
    StatEntry.create = function create(properties) {
      return new StatEntry(properties);
    };

    /**
     * Encodes the specified StatEntry message. Does not implicitly {@link qud.StatEntry.verify|verify} messages.
     * @function encode
     * @memberof qud.StatEntry
     * @static
     * @param {qud.IStatEntry} message StatEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StatEntry.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.key != null && Object.hasOwnProperty.call(message, 'key'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.key);
      if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.value);
      return writer;
    };

    /**
     * Encodes the specified StatEntry message, length delimited. Does not implicitly {@link qud.StatEntry.verify|verify} messages.
     * @function encodeDelimited
     * @memberof qud.StatEntry
     * @static
     * @param {qud.IStatEntry} message StatEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StatEntry.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a StatEntry message from the specified reader or buffer.
     * @function decode
     * @memberof qud.StatEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {qud.StatEntry} StatEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StatEntry.decode = function decode(reader, length, error) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.qud.StatEntry();
      while (reader.pos < end) {
        let tag = reader.uint32();
        if (tag === error) break;
        switch (tag >>> 3) {
          case 1: {
            message.key = reader.string();
            break;
          }
          case 2: {
            message.value = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a StatEntry message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof qud.StatEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {qud.StatEntry} StatEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StatEntry.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a StatEntry message.
     * @function verify
     * @memberof qud.StatEntry
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    StatEntry.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.key != null && message.hasOwnProperty('key'))
        if (!$util.isString(message.key)) return 'key: string expected';
      if (message.value != null && message.hasOwnProperty('value'))
        if (!$util.isInteger(message.value)) return 'value: integer expected';
      return null;
    };

    /**
     * Creates a StatEntry message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof qud.StatEntry
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {qud.StatEntry} StatEntry
     */
    StatEntry.fromObject = function fromObject(object) {
      if (object instanceof $root.qud.StatEntry) return object;
      let message = new $root.qud.StatEntry();
      if (object.key != null) message.key = String(object.key);
      if (object.value != null) message.value = object.value | 0;
      return message;
    };

    /**
     * Creates a plain object from a StatEntry message. Also converts values to other types if specified.
     * @function toObject
     * @memberof qud.StatEntry
     * @static
     * @param {qud.StatEntry} message StatEntry
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StatEntry.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.key = '';
        object.value = 0;
      }
      if (message.key != null && message.hasOwnProperty('key')) object.key = message.key;
      if (message.value != null && message.hasOwnProperty('value')) object.value = message.value;
      return object;
    };

    /**
     * Converts this StatEntry to JSON.
     * @function toJSON
     * @memberof qud.StatEntry
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StatEntry.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for StatEntry
     * @function getTypeUrl
     * @memberof qud.StatEntry
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    StatEntry.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
      if (typeUrlPrefix === undefined) {
        typeUrlPrefix = 'type.googleapis.com';
      }
      return typeUrlPrefix + '/qud.StatEntry';
    };

    return StatEntry;
  })();

  qud.TagEntry = (function () {
    /**
     * Properties of a TagEntry.
     * @memberof qud
     * @interface ITagEntry
     * @property {string|null} [key] TagEntry key
     * @property {string|null} [value] TagEntry value
     */

    /**
     * Constructs a new TagEntry.
     * @memberof qud
     * @classdesc Represents a TagEntry.
     * @implements ITagEntry
     * @constructor
     * @param {qud.ITagEntry=} [properties] Properties to set
     */
    function TagEntry(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * TagEntry key.
     * @member {string} key
     * @memberof qud.TagEntry
     * @instance
     */
    TagEntry.prototype.key = '';

    /**
     * TagEntry value.
     * @member {string} value
     * @memberof qud.TagEntry
     * @instance
     */
    TagEntry.prototype.value = '';

    /**
     * Creates a new TagEntry instance using the specified properties.
     * @function create
     * @memberof qud.TagEntry
     * @static
     * @param {qud.ITagEntry=} [properties] Properties to set
     * @returns {qud.TagEntry} TagEntry instance
     */
    TagEntry.create = function create(properties) {
      return new TagEntry(properties);
    };

    /**
     * Encodes the specified TagEntry message. Does not implicitly {@link qud.TagEntry.verify|verify} messages.
     * @function encode
     * @memberof qud.TagEntry
     * @static
     * @param {qud.ITagEntry} message TagEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TagEntry.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.key != null && Object.hasOwnProperty.call(message, 'key'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.key);
      if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.value);
      return writer;
    };

    /**
     * Encodes the specified TagEntry message, length delimited. Does not implicitly {@link qud.TagEntry.verify|verify} messages.
     * @function encodeDelimited
     * @memberof qud.TagEntry
     * @static
     * @param {qud.ITagEntry} message TagEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TagEntry.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TagEntry message from the specified reader or buffer.
     * @function decode
     * @memberof qud.TagEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {qud.TagEntry} TagEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TagEntry.decode = function decode(reader, length, error) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.qud.TagEntry();
      while (reader.pos < end) {
        let tag = reader.uint32();
        if (tag === error) break;
        switch (tag >>> 3) {
          case 1: {
            message.key = reader.string();
            break;
          }
          case 2: {
            message.value = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a TagEntry message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof qud.TagEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {qud.TagEntry} TagEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TagEntry.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TagEntry message.
     * @function verify
     * @memberof qud.TagEntry
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TagEntry.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.key != null && message.hasOwnProperty('key'))
        if (!$util.isString(message.key)) return 'key: string expected';
      if (message.value != null && message.hasOwnProperty('value'))
        if (!$util.isString(message.value)) return 'value: string expected';
      return null;
    };

    /**
     * Creates a TagEntry message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof qud.TagEntry
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {qud.TagEntry} TagEntry
     */
    TagEntry.fromObject = function fromObject(object) {
      if (object instanceof $root.qud.TagEntry) return object;
      let message = new $root.qud.TagEntry();
      if (object.key != null) message.key = String(object.key);
      if (object.value != null) message.value = String(object.value);
      return message;
    };

    /**
     * Creates a plain object from a TagEntry message. Also converts values to other types if specified.
     * @function toObject
     * @memberof qud.TagEntry
     * @static
     * @param {qud.TagEntry} message TagEntry
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TagEntry.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.key = '';
        object.value = '';
      }
      if (message.key != null && message.hasOwnProperty('key')) object.key = message.key;
      if (message.value != null && message.hasOwnProperty('value')) object.value = message.value;
      return object;
    };

    /**
     * Converts this TagEntry to JSON.
     * @function toJSON
     * @memberof qud.TagEntry
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TagEntry.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TagEntry
     * @function getTypeUrl
     * @memberof qud.TagEntry
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TagEntry.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
      if (typeUrlPrefix === undefined) {
        typeUrlPrefix = 'type.googleapis.com';
      }
      return typeUrlPrefix + '/qud.TagEntry';
    };

    return TagEntry;
  })();

  qud.RawBlueprintDef = (function () {
    /**
     * Properties of a RawBlueprintDef.
     * @memberof qud
     * @interface IRawBlueprintDef
     * @property {string|null} [inherits] RawBlueprintDef inherits
     * @property {Array.<qud.IPartDef>|null} [parts] RawBlueprintDef parts
     * @property {Array.<qud.IPartDef>|null} [builders] RawBlueprintDef builders
     * @property {Array.<qud.ITagEntry>|null} [tags] RawBlueprintDef tags
     * @property {Array.<qud.IStatEntry>|null} [stats] RawBlueprintDef stats
     * @property {Array.<string>|null} [removeParts] RawBlueprintDef removeParts
     * @property {Array.<string>|null} [removeBuilders] RawBlueprintDef removeBuilders
     */

    /**
     * Constructs a new RawBlueprintDef.
     * @memberof qud
     * @classdesc Represents a RawBlueprintDef.
     * @implements IRawBlueprintDef
     * @constructor
     * @param {qud.IRawBlueprintDef=} [properties] Properties to set
     */
    function RawBlueprintDef(properties) {
      this.parts = [];
      this.builders = [];
      this.tags = [];
      this.stats = [];
      this.removeParts = [];
      this.removeBuilders = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * RawBlueprintDef inherits.
     * @member {string} inherits
     * @memberof qud.RawBlueprintDef
     * @instance
     */
    RawBlueprintDef.prototype.inherits = '';

    /**
     * RawBlueprintDef parts.
     * @member {Array.<qud.IPartDef>} parts
     * @memberof qud.RawBlueprintDef
     * @instance
     */
    RawBlueprintDef.prototype.parts = $util.emptyArray;

    /**
     * RawBlueprintDef builders.
     * @member {Array.<qud.IPartDef>} builders
     * @memberof qud.RawBlueprintDef
     * @instance
     */
    RawBlueprintDef.prototype.builders = $util.emptyArray;

    /**
     * RawBlueprintDef tags.
     * @member {Array.<qud.ITagEntry>} tags
     * @memberof qud.RawBlueprintDef
     * @instance
     */
    RawBlueprintDef.prototype.tags = $util.emptyArray;

    /**
     * RawBlueprintDef stats.
     * @member {Array.<qud.IStatEntry>} stats
     * @memberof qud.RawBlueprintDef
     * @instance
     */
    RawBlueprintDef.prototype.stats = $util.emptyArray;

    /**
     * RawBlueprintDef removeParts.
     * @member {Array.<string>} removeParts
     * @memberof qud.RawBlueprintDef
     * @instance
     */
    RawBlueprintDef.prototype.removeParts = $util.emptyArray;

    /**
     * RawBlueprintDef removeBuilders.
     * @member {Array.<string>} removeBuilders
     * @memberof qud.RawBlueprintDef
     * @instance
     */
    RawBlueprintDef.prototype.removeBuilders = $util.emptyArray;

    /**
     * Creates a new RawBlueprintDef instance using the specified properties.
     * @function create
     * @memberof qud.RawBlueprintDef
     * @static
     * @param {qud.IRawBlueprintDef=} [properties] Properties to set
     * @returns {qud.RawBlueprintDef} RawBlueprintDef instance
     */
    RawBlueprintDef.create = function create(properties) {
      return new RawBlueprintDef(properties);
    };

    /**
     * Encodes the specified RawBlueprintDef message. Does not implicitly {@link qud.RawBlueprintDef.verify|verify} messages.
     * @function encode
     * @memberof qud.RawBlueprintDef
     * @static
     * @param {qud.IRawBlueprintDef} message RawBlueprintDef message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RawBlueprintDef.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.inherits != null && Object.hasOwnProperty.call(message, 'inherits'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.inherits);
      if (message.parts != null && message.parts.length)
        for (let i = 0; i < message.parts.length; ++i)
          $root.qud.PartDef.encode(
            message.parts[i],
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
      if (message.builders != null && message.builders.length)
        for (let i = 0; i < message.builders.length; ++i)
          $root.qud.PartDef.encode(
            message.builders[i],
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
      if (message.tags != null && message.tags.length)
        for (let i = 0; i < message.tags.length; ++i)
          $root.qud.TagEntry.encode(
            message.tags[i],
            writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
          ).ldelim();
      if (message.stats != null && message.stats.length)
        for (let i = 0; i < message.stats.length; ++i)
          $root.qud.StatEntry.encode(
            message.stats[i],
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
          ).ldelim();
      if (message.removeParts != null && message.removeParts.length)
        for (let i = 0; i < message.removeParts.length; ++i)
          writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.removeParts[i]);
      if (message.removeBuilders != null && message.removeBuilders.length)
        for (let i = 0; i < message.removeBuilders.length; ++i)
          writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.removeBuilders[i]);
      return writer;
    };

    /**
     * Encodes the specified RawBlueprintDef message, length delimited. Does not implicitly {@link qud.RawBlueprintDef.verify|verify} messages.
     * @function encodeDelimited
     * @memberof qud.RawBlueprintDef
     * @static
     * @param {qud.IRawBlueprintDef} message RawBlueprintDef message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RawBlueprintDef.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RawBlueprintDef message from the specified reader or buffer.
     * @function decode
     * @memberof qud.RawBlueprintDef
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {qud.RawBlueprintDef} RawBlueprintDef
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RawBlueprintDef.decode = function decode(reader, length, error) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.qud.RawBlueprintDef();
      while (reader.pos < end) {
        let tag = reader.uint32();
        if (tag === error) break;
        switch (tag >>> 3) {
          case 1: {
            message.inherits = reader.string();
            break;
          }
          case 2: {
            if (!(message.parts && message.parts.length)) message.parts = [];
            message.parts.push($root.qud.PartDef.decode(reader, reader.uint32()));
            break;
          }
          case 3: {
            if (!(message.builders && message.builders.length)) message.builders = [];
            message.builders.push($root.qud.PartDef.decode(reader, reader.uint32()));
            break;
          }
          case 4: {
            if (!(message.tags && message.tags.length)) message.tags = [];
            message.tags.push($root.qud.TagEntry.decode(reader, reader.uint32()));
            break;
          }
          case 5: {
            if (!(message.stats && message.stats.length)) message.stats = [];
            message.stats.push($root.qud.StatEntry.decode(reader, reader.uint32()));
            break;
          }
          case 6: {
            if (!(message.removeParts && message.removeParts.length)) message.removeParts = [];
            message.removeParts.push(reader.string());
            break;
          }
          case 7: {
            if (!(message.removeBuilders && message.removeBuilders.length))
              message.removeBuilders = [];
            message.removeBuilders.push(reader.string());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a RawBlueprintDef message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof qud.RawBlueprintDef
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {qud.RawBlueprintDef} RawBlueprintDef
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RawBlueprintDef.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RawBlueprintDef message.
     * @function verify
     * @memberof qud.RawBlueprintDef
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RawBlueprintDef.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.inherits != null && message.hasOwnProperty('inherits'))
        if (!$util.isString(message.inherits)) return 'inherits: string expected';
      if (message.parts != null && message.hasOwnProperty('parts')) {
        if (!Array.isArray(message.parts)) return 'parts: array expected';
        for (let i = 0; i < message.parts.length; ++i) {
          let error = $root.qud.PartDef.verify(message.parts[i]);
          if (error) return 'parts.' + error;
        }
      }
      if (message.builders != null && message.hasOwnProperty('builders')) {
        if (!Array.isArray(message.builders)) return 'builders: array expected';
        for (let i = 0; i < message.builders.length; ++i) {
          let error = $root.qud.PartDef.verify(message.builders[i]);
          if (error) return 'builders.' + error;
        }
      }
      if (message.tags != null && message.hasOwnProperty('tags')) {
        if (!Array.isArray(message.tags)) return 'tags: array expected';
        for (let i = 0; i < message.tags.length; ++i) {
          let error = $root.qud.TagEntry.verify(message.tags[i]);
          if (error) return 'tags.' + error;
        }
      }
      if (message.stats != null && message.hasOwnProperty('stats')) {
        if (!Array.isArray(message.stats)) return 'stats: array expected';
        for (let i = 0; i < message.stats.length; ++i) {
          let error = $root.qud.StatEntry.verify(message.stats[i]);
          if (error) return 'stats.' + error;
        }
      }
      if (message.removeParts != null && message.hasOwnProperty('removeParts')) {
        if (!Array.isArray(message.removeParts)) return 'removeParts: array expected';
        for (let i = 0; i < message.removeParts.length; ++i)
          if (!$util.isString(message.removeParts[i])) return 'removeParts: string[] expected';
      }
      if (message.removeBuilders != null && message.hasOwnProperty('removeBuilders')) {
        if (!Array.isArray(message.removeBuilders)) return 'removeBuilders: array expected';
        for (let i = 0; i < message.removeBuilders.length; ++i)
          if (!$util.isString(message.removeBuilders[i]))
            return 'removeBuilders: string[] expected';
      }
      return null;
    };

    /**
     * Creates a RawBlueprintDef message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof qud.RawBlueprintDef
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {qud.RawBlueprintDef} RawBlueprintDef
     */
    RawBlueprintDef.fromObject = function fromObject(object) {
      if (object instanceof $root.qud.RawBlueprintDef) return object;
      let message = new $root.qud.RawBlueprintDef();
      if (object.inherits != null) message.inherits = String(object.inherits);
      if (object.parts) {
        if (!Array.isArray(object.parts))
          throw TypeError('.qud.RawBlueprintDef.parts: array expected');
        message.parts = [];
        for (let i = 0; i < object.parts.length; ++i) {
          if (typeof object.parts[i] !== 'object')
            throw TypeError('.qud.RawBlueprintDef.parts: object expected');
          message.parts[i] = $root.qud.PartDef.fromObject(object.parts[i]);
        }
      }
      if (object.builders) {
        if (!Array.isArray(object.builders))
          throw TypeError('.qud.RawBlueprintDef.builders: array expected');
        message.builders = [];
        for (let i = 0; i < object.builders.length; ++i) {
          if (typeof object.builders[i] !== 'object')
            throw TypeError('.qud.RawBlueprintDef.builders: object expected');
          message.builders[i] = $root.qud.PartDef.fromObject(object.builders[i]);
        }
      }
      if (object.tags) {
        if (!Array.isArray(object.tags))
          throw TypeError('.qud.RawBlueprintDef.tags: array expected');
        message.tags = [];
        for (let i = 0; i < object.tags.length; ++i) {
          if (typeof object.tags[i] !== 'object')
            throw TypeError('.qud.RawBlueprintDef.tags: object expected');
          message.tags[i] = $root.qud.TagEntry.fromObject(object.tags[i]);
        }
      }
      if (object.stats) {
        if (!Array.isArray(object.stats))
          throw TypeError('.qud.RawBlueprintDef.stats: array expected');
        message.stats = [];
        for (let i = 0; i < object.stats.length; ++i) {
          if (typeof object.stats[i] !== 'object')
            throw TypeError('.qud.RawBlueprintDef.stats: object expected');
          message.stats[i] = $root.qud.StatEntry.fromObject(object.stats[i]);
        }
      }
      if (object.removeParts) {
        if (!Array.isArray(object.removeParts))
          throw TypeError('.qud.RawBlueprintDef.removeParts: array expected');
        message.removeParts = [];
        for (let i = 0; i < object.removeParts.length; ++i)
          message.removeParts[i] = String(object.removeParts[i]);
      }
      if (object.removeBuilders) {
        if (!Array.isArray(object.removeBuilders))
          throw TypeError('.qud.RawBlueprintDef.removeBuilders: array expected');
        message.removeBuilders = [];
        for (let i = 0; i < object.removeBuilders.length; ++i)
          message.removeBuilders[i] = String(object.removeBuilders[i]);
      }
      return message;
    };

    /**
     * Creates a plain object from a RawBlueprintDef message. Also converts values to other types if specified.
     * @function toObject
     * @memberof qud.RawBlueprintDef
     * @static
     * @param {qud.RawBlueprintDef} message RawBlueprintDef
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RawBlueprintDef.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.parts = [];
        object.builders = [];
        object.tags = [];
        object.stats = [];
        object.removeParts = [];
        object.removeBuilders = [];
      }
      if (options.defaults) object.inherits = '';
      if (message.inherits != null && message.hasOwnProperty('inherits'))
        object.inherits = message.inherits;
      if (message.parts && message.parts.length) {
        object.parts = [];
        for (let j = 0; j < message.parts.length; ++j)
          object.parts[j] = $root.qud.PartDef.toObject(message.parts[j], options);
      }
      if (message.builders && message.builders.length) {
        object.builders = [];
        for (let j = 0; j < message.builders.length; ++j)
          object.builders[j] = $root.qud.PartDef.toObject(message.builders[j], options);
      }
      if (message.tags && message.tags.length) {
        object.tags = [];
        for (let j = 0; j < message.tags.length; ++j)
          object.tags[j] = $root.qud.TagEntry.toObject(message.tags[j], options);
      }
      if (message.stats && message.stats.length) {
        object.stats = [];
        for (let j = 0; j < message.stats.length; ++j)
          object.stats[j] = $root.qud.StatEntry.toObject(message.stats[j], options);
      }
      if (message.removeParts && message.removeParts.length) {
        object.removeParts = [];
        for (let j = 0; j < message.removeParts.length; ++j)
          object.removeParts[j] = message.removeParts[j];
      }
      if (message.removeBuilders && message.removeBuilders.length) {
        object.removeBuilders = [];
        for (let j = 0; j < message.removeBuilders.length; ++j)
          object.removeBuilders[j] = message.removeBuilders[j];
      }
      return object;
    };

    /**
     * Converts this RawBlueprintDef to JSON.
     * @function toJSON
     * @memberof qud.RawBlueprintDef
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RawBlueprintDef.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RawBlueprintDef
     * @function getTypeUrl
     * @memberof qud.RawBlueprintDef
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RawBlueprintDef.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
      if (typeUrlPrefix === undefined) {
        typeUrlPrefix = 'type.googleapis.com';
      }
      return typeUrlPrefix + '/qud.RawBlueprintDef';
    };

    return RawBlueprintDef;
  })();

  qud.BlueprintEntry = (function () {
    /**
     * Properties of a BlueprintEntry.
     * @memberof qud
     * @interface IBlueprintEntry
     * @property {string|null} [name] BlueprintEntry name
     * @property {qud.IRawBlueprintDef|null} [def] BlueprintEntry def
     */

    /**
     * Constructs a new BlueprintEntry.
     * @memberof qud
     * @classdesc Represents a BlueprintEntry.
     * @implements IBlueprintEntry
     * @constructor
     * @param {qud.IBlueprintEntry=} [properties] Properties to set
     */
    function BlueprintEntry(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * BlueprintEntry name.
     * @member {string} name
     * @memberof qud.BlueprintEntry
     * @instance
     */
    BlueprintEntry.prototype.name = '';

    /**
     * BlueprintEntry def.
     * @member {qud.IRawBlueprintDef|null|undefined} def
     * @memberof qud.BlueprintEntry
     * @instance
     */
    BlueprintEntry.prototype.def = null;

    /**
     * Creates a new BlueprintEntry instance using the specified properties.
     * @function create
     * @memberof qud.BlueprintEntry
     * @static
     * @param {qud.IBlueprintEntry=} [properties] Properties to set
     * @returns {qud.BlueprintEntry} BlueprintEntry instance
     */
    BlueprintEntry.create = function create(properties) {
      return new BlueprintEntry(properties);
    };

    /**
     * Encodes the specified BlueprintEntry message. Does not implicitly {@link qud.BlueprintEntry.verify|verify} messages.
     * @function encode
     * @memberof qud.BlueprintEntry
     * @static
     * @param {qud.IBlueprintEntry} message BlueprintEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BlueprintEntry.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.name != null && Object.hasOwnProperty.call(message, 'name'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
      if (message.def != null && Object.hasOwnProperty.call(message, 'def'))
        $root.qud.RawBlueprintDef.encode(
          message.def,
          writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified BlueprintEntry message, length delimited. Does not implicitly {@link qud.BlueprintEntry.verify|verify} messages.
     * @function encodeDelimited
     * @memberof qud.BlueprintEntry
     * @static
     * @param {qud.IBlueprintEntry} message BlueprintEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BlueprintEntry.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BlueprintEntry message from the specified reader or buffer.
     * @function decode
     * @memberof qud.BlueprintEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {qud.BlueprintEntry} BlueprintEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BlueprintEntry.decode = function decode(reader, length, error) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.qud.BlueprintEntry();
      while (reader.pos < end) {
        let tag = reader.uint32();
        if (tag === error) break;
        switch (tag >>> 3) {
          case 1: {
            message.name = reader.string();
            break;
          }
          case 2: {
            message.def = $root.qud.RawBlueprintDef.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a BlueprintEntry message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof qud.BlueprintEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {qud.BlueprintEntry} BlueprintEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BlueprintEntry.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BlueprintEntry message.
     * @function verify
     * @memberof qud.BlueprintEntry
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BlueprintEntry.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.name != null && message.hasOwnProperty('name'))
        if (!$util.isString(message.name)) return 'name: string expected';
      if (message.def != null && message.hasOwnProperty('def')) {
        let error = $root.qud.RawBlueprintDef.verify(message.def);
        if (error) return 'def.' + error;
      }
      return null;
    };

    /**
     * Creates a BlueprintEntry message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof qud.BlueprintEntry
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {qud.BlueprintEntry} BlueprintEntry
     */
    BlueprintEntry.fromObject = function fromObject(object) {
      if (object instanceof $root.qud.BlueprintEntry) return object;
      let message = new $root.qud.BlueprintEntry();
      if (object.name != null) message.name = String(object.name);
      if (object.def != null) {
        if (typeof object.def !== 'object')
          throw TypeError('.qud.BlueprintEntry.def: object expected');
        message.def = $root.qud.RawBlueprintDef.fromObject(object.def);
      }
      return message;
    };

    /**
     * Creates a plain object from a BlueprintEntry message. Also converts values to other types if specified.
     * @function toObject
     * @memberof qud.BlueprintEntry
     * @static
     * @param {qud.BlueprintEntry} message BlueprintEntry
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BlueprintEntry.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.name = '';
        object.def = null;
      }
      if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
      if (message.def != null && message.hasOwnProperty('def'))
        object.def = $root.qud.RawBlueprintDef.toObject(message.def, options);
      return object;
    };

    /**
     * Converts this BlueprintEntry to JSON.
     * @function toJSON
     * @memberof qud.BlueprintEntry
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BlueprintEntry.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BlueprintEntry
     * @function getTypeUrl
     * @memberof qud.BlueprintEntry
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BlueprintEntry.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
      if (typeUrlPrefix === undefined) {
        typeUrlPrefix = 'type.googleapis.com';
      }
      return typeUrlPrefix + '/qud.BlueprintEntry';
    };

    return BlueprintEntry;
  })();

  qud.BlueprintData = (function () {
    /**
     * Properties of a BlueprintData.
     * @memberof qud
     * @interface IBlueprintData
     * @property {Array.<qud.IBlueprintEntry>|null} [blueprints] BlueprintData blueprints
     */

    /**
     * Constructs a new BlueprintData.
     * @memberof qud
     * @classdesc Represents a BlueprintData.
     * @implements IBlueprintData
     * @constructor
     * @param {qud.IBlueprintData=} [properties] Properties to set
     */
    function BlueprintData(properties) {
      this.blueprints = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * BlueprintData blueprints.
     * @member {Array.<qud.IBlueprintEntry>} blueprints
     * @memberof qud.BlueprintData
     * @instance
     */
    BlueprintData.prototype.blueprints = $util.emptyArray;

    /**
     * Creates a new BlueprintData instance using the specified properties.
     * @function create
     * @memberof qud.BlueprintData
     * @static
     * @param {qud.IBlueprintData=} [properties] Properties to set
     * @returns {qud.BlueprintData} BlueprintData instance
     */
    BlueprintData.create = function create(properties) {
      return new BlueprintData(properties);
    };

    /**
     * Encodes the specified BlueprintData message. Does not implicitly {@link qud.BlueprintData.verify|verify} messages.
     * @function encode
     * @memberof qud.BlueprintData
     * @static
     * @param {qud.IBlueprintData} message BlueprintData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BlueprintData.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.blueprints != null && message.blueprints.length)
        for (let i = 0; i < message.blueprints.length; ++i)
          $root.qud.BlueprintEntry.encode(
            message.blueprints[i],
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified BlueprintData message, length delimited. Does not implicitly {@link qud.BlueprintData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof qud.BlueprintData
     * @static
     * @param {qud.IBlueprintData} message BlueprintData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BlueprintData.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BlueprintData message from the specified reader or buffer.
     * @function decode
     * @memberof qud.BlueprintData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {qud.BlueprintData} BlueprintData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BlueprintData.decode = function decode(reader, length, error) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.qud.BlueprintData();
      while (reader.pos < end) {
        let tag = reader.uint32();
        if (tag === error) break;
        switch (tag >>> 3) {
          case 1: {
            if (!(message.blueprints && message.blueprints.length)) message.blueprints = [];
            message.blueprints.push($root.qud.BlueprintEntry.decode(reader, reader.uint32()));
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a BlueprintData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof qud.BlueprintData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {qud.BlueprintData} BlueprintData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BlueprintData.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BlueprintData message.
     * @function verify
     * @memberof qud.BlueprintData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BlueprintData.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.blueprints != null && message.hasOwnProperty('blueprints')) {
        if (!Array.isArray(message.blueprints)) return 'blueprints: array expected';
        for (let i = 0; i < message.blueprints.length; ++i) {
          let error = $root.qud.BlueprintEntry.verify(message.blueprints[i]);
          if (error) return 'blueprints.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a BlueprintData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof qud.BlueprintData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {qud.BlueprintData} BlueprintData
     */
    BlueprintData.fromObject = function fromObject(object) {
      if (object instanceof $root.qud.BlueprintData) return object;
      let message = new $root.qud.BlueprintData();
      if (object.blueprints) {
        if (!Array.isArray(object.blueprints))
          throw TypeError('.qud.BlueprintData.blueprints: array expected');
        message.blueprints = [];
        for (let i = 0; i < object.blueprints.length; ++i) {
          if (typeof object.blueprints[i] !== 'object')
            throw TypeError('.qud.BlueprintData.blueprints: object expected');
          message.blueprints[i] = $root.qud.BlueprintEntry.fromObject(object.blueprints[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a BlueprintData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof qud.BlueprintData
     * @static
     * @param {qud.BlueprintData} message BlueprintData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BlueprintData.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.blueprints = [];
      if (message.blueprints && message.blueprints.length) {
        object.blueprints = [];
        for (let j = 0; j < message.blueprints.length; ++j)
          object.blueprints[j] = $root.qud.BlueprintEntry.toObject(message.blueprints[j], options);
      }
      return object;
    };

    /**
     * Converts this BlueprintData to JSON.
     * @function toJSON
     * @memberof qud.BlueprintData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BlueprintData.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BlueprintData
     * @function getTypeUrl
     * @memberof qud.BlueprintData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BlueprintData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
      if (typeUrlPrefix === undefined) {
        typeUrlPrefix = 'type.googleapis.com';
      }
      return typeUrlPrefix + '/qud.BlueprintData';
    };

    return BlueprintData;
  })();

  return qud;
})());

export { $root as default };
